import { useFetch2 } from "../../util";

export type HeaderFormat = "TEXT" | "IMAGE" | "VIDEO" | "DOCUMENT";
export type ComponentType = "HEADER" | "BODY" | "FOOTER" | "BUTTONS";
export type ButtonType = "QUICK_REPLY" | "COPY_CODE" | "URL";

export type ParameterFormat = "NAMED" | "POSITIONAL";

export interface WhatsAppTemplatesOutput {
  data: TemplateDto[];
}

export interface TemplateDto {
  name: string;
  category: string;
  language: string;

  parameter_format?: ParameterFormat;

  components?: ComponentDto[];

  status?: string;

  id: string;
}

export type TemplateInputDto = Omit<TemplateDto, "id" | "status">;

export interface ExampleNamedParam {
  param_name: string;
  example: string;
}

export interface ExampleDto {
  body_text?: string[][];
  header_text?: string[];

  body_text_named_params?: ExampleNamedParam[];
  header_text_named_params?: ExampleNamedParam[];

  header_handle?: string[];
}

export type ButtonDto =
  | { type: "QUICK_REPLY"; text: string }
  | { type: "COPY_CODE"; example: string[] }
  | { type: "URL"; text: string; url: string };

export interface ComponentDto {
  type: ComponentType;
  format?: HeaderFormat;
  text?: string;
  example?: ExampleDto;
  buttons?: ButtonDto[];
}

export type WhatsAppTemplateUpsertPayload = TemplateInputDto & {
  message_send_ttl_seconds?: number | null;
};

export default function useWhatsAppTemplatesApi() {
  const fetch = useFetch2();

  const getTemplates = (botId: number) =>
    fetch<WhatsAppTemplatesOutput>(`/api/bots/${botId}/whatsapp/templates`, {
      method: "GET"
    });

  const createTemplate = (botId: number, data: WhatsAppTemplateUpsertPayload) =>
    fetch(
      `/api/bots/${botId}/whatsapp/create-templates`,
      { method: "POST" },
      data
    );

  const editTemplate = (
    botId: number,
    templateId: string,
    data: WhatsAppTemplateUpsertPayload
  ) =>
    fetch(
      `/api/bots/${botId}/whatsapp/edit-templates/${templateId}`,
      { method: "POST" },
      data
    );

  const deleteTemplate = (botId: number, hsmId: string, name: string) =>
    fetch(
      `/api/bots/${botId}/whatsapp/templates?hsm_id=${encodeURIComponent(
        hsmId
      )}&name=${encodeURIComponent(name)}`,
      { method: "DELETE" }
    );

  return { getTemplates, createTemplate, editTemplate, deleteTemplate };
}
